<script>
/* eslint-disable */
import { Pie } from 'vue-chartjs'
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels'

export default {
  extends: Pie,
  props: ['chartdata', 'options'],

  data: function () {
    return {
      initialized: false
    }
  },

  methods: {
    render: function () {
      if (this.initialized) {
        this.$data._chart.update()
      } else {
        this.renderChart(this.chartdata, this.options)
      }
    }
  },

  mounted () {
    if (this.chartdata) {
      this.render()
      this.initialized = true
    }
  },

  watch: {
    chartdata () {
      this.render()
    }
  }
}
</script>
